import React, { FC } from 'react';
import { ClassNameOnlyProps } from 'components/ozone-component';
import { GroupByFilter, Option } from '../filter';
import { ViewFilter } from '../filter/view-filter';
import { AllowedFilterItem } from './get-render-data';

interface FilterMenuProps extends ClassNameOnlyProps {
  onChange?: (filter) => void;
}

export const FilterMenu: FC<FilterMenuProps> = (props) => {
  const { onChange } = props;
  const handleViewChange = (selected: Option) => {
    if (onChange) {
      onChange({ view: selected.value });
    }
  };
  const handleGroupByChange = (selected: Option) => {
    if (onChange) {
      onChange({ [AllowedFilterItem.GroupBy]: selected.value });
    }
  };

  return (
    <>
      <ViewFilter onChange={handleViewChange} />
      <GroupByFilter onChange={handleGroupByChange} />
    </>
  );
};
